import { SyncServiceProvider } from "~/environment/shared-worker/SyncService";

export function observeIsInitialSyncComplete() {
  return SyncServiceProvider.isInitialSyncComplete$;
}
